(ns ballot-scout-v2-frontend.disposition-manager.common)

(def default-search-state
  {:page 1})
